(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["meris-footer"] && !Shopify.designMode) return;
  try {
    
  if (!window.merisFooterAccordionReady) {
    window.merisFooterAccordionReady = true;

    document.addEventListener('toggle', (event) => {
      const activeGroup = event.target;

      if (!(activeGroup instanceof HTMLDetailsElement)) return;
      if (!activeGroup.matches('[data-meris-footer-accordion]')) return;
      if (!activeGroup.open) return;

      const navigation = activeGroup.closest('[data-meris-footer-nav]');
      if (!navigation) return;

      navigation.querySelectorAll('[data-meris-footer-accordion][open]').forEach((group) => {
        if (group !== activeGroup) group.open = false;
      });
    }, true);
  }

  } catch(e) { console.error(e); }
})();
})();
